import { useQuery, useMutation, useQueryClient } from 'react-query'
import axios from 'axios'

const ENDPOINT = '/api/promotions/dealer/mystery-shoppers/companies'
const QUERY_KEY = 'mystery-shopper-companies'

export const useGetMysteryShopperCompanies = (config = {}) =>
  useQuery(QUERY_KEY, async () => (await axios.get(ENDPOINT)).data, config)

// Uploads an .xlsx file (as multipart FormData under the `file` field) that
// replaces all company data. Invalidates the cached list on success so the
// dealer form's autocomplete reflects the new data.
export const useImportMysteryShopperCompanies = (config = {}) => {
  const queryClient = useQueryClient()

  return useMutation((formData) => axios.post(`${ENDPOINT}/import`, formData), {
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(QUERY_KEY)
      config.onSuccess?.(...args)
    },
  })
}
